// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__J6rUh","inverse":"button_inverse__KYkNc","small":"button_small__wlyPh","disabled":"button_disabled__dZnSt"};